import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMembers, getTodayRewards, editProfile, sendOtp, getMyProfile, getLevel, getReferralCode, getReferralLink, getAffiliateAll, getDepositBonusLevelHistory, getBetBonusLevelHistory, updatePreferences } from '../api/userApi';

export const useMembersQuery = (uid) => {
  return useQuery({
    queryKey: ['members', uid],
    queryFn: () => getMembers(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useTodayRewardsQuery = (uid) => {
  return useQuery({
    queryKey: ['todayRewards', uid],
    queryFn: () => getTodayRewards(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useEditProfileMutation = () => {
  return useMutation({
    mutationFn: editProfile,
  });
};

export const useSendOtpMutation = () => {
  return useMutation({
    mutationFn: sendOtp,
  });
};

export const useMyProfileQuery = (uid) => {
  return useQuery({
    queryKey: ['myProfile', uid],
    queryFn: () => getMyProfile(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useLevelQuery = () => {
  return useQuery({
    queryKey: ['levels'],
    queryFn: getLevel,
    refetchOnWindowFocus: false,
  });
};

export const useReferralCodeQuery = (uid) => {
  return useQuery({
    queryKey: ['referralCode', uid],
    queryFn: () => getReferralCode(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useReferralLinkQuery = (uid) => {
  return useQuery({
    queryKey: ['referralLink', uid],
    queryFn: () => getReferralLink(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliateAllQuery = (uid) => {
  return useQuery({
    queryKey: ['affiliateAll', uid],
    queryFn: () => getAffiliateAll(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useDepositBonusLevelHistoryQuery = (uid) => {
  return useQuery({
    queryKey: ['depositBonusHistory', uid],
    queryFn: () => getDepositBonusLevelHistory(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useBetBonusLevelHistoryQuery = (uid) => {
  return useQuery({
    queryKey: ['betBonusHistory', uid],
    queryFn: () => getBetBonusLevelHistory(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useUpdatePreferencesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePreferences,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['myProfile', variables.uid]);
    }
  });
};
